
/**
 * @typedef {object} ISheetResource
 * @property {() => ng.resource.IResource<{ items?: import('types/api').V1.SheetFromAPI[] }>} query
 * @property {(sheet: any) => ng.resource.IResource<import('types/api').V1.SheetFromAPI>} save
 * @property {(sheet: { id: string }) => ng.resource.IResource<import('types/api').V1.SheetFromAPI>} delete
 * @property {(sheet: { id: string }, args: any) => ng.resource.IResource<import('types/api').V1.SheetFromAPI>} update
 */

export default [
  '$resource',
  'resourceActions',
  SheetResource
];

/**
 * @param {ng.resource.IResourceService} $resource
 * @return {ISheetResource}
 */
export function SheetResource($resource, resourceActions) {
  var actions = angular.copy(resourceActions, {});
  actions['query']['isArray'] = false;

  /** @ts-ignore */
  return $resource(
    '/api/v1/sheets/:id',
    { id: '@id' },
    actions,
  );
}